import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { isArray, uniqueId } from 'lodash';
import Container from '../Container';
import ErrorMessage from '../ErrorMessage';
import PageHeader from '../PageHeader';

const Error = styled(ErrorMessage)`
  margin-bottom: 10px;
`;

class FormPageLayout extends React.Component {
  state = {
    isEditing: false,
    loadingError: '',
  };

  componentDidMount() {
    this.props.onMount().catch(error => this.setState({ loadingError: error }));
  }

  handleEdit = () => {
    this.setState({
      isEditing: true,
    });
  };

  handleCancel = () => {
    this.setState({
      isEditing: false,
    });
  };

  render() {
    const {
      data,
      detailsComponent: DetailsComponent,
      formComponent: FormComponent,
      itemComponent: ItemComponent,
      hasData,
      isLoading,
      onContinue,
      onSave,
      title,
      ...rest
    } = this.props;
    const { isEditing, loadingError } = this.state;
    const shouldShowForm = !hasData || isEditing;
    const formData = isArray(data)
      ? data
      : [{ tempId: uniqueId('temp-'), ...data }];
    return (
      <Container>
        <PageHeader
          onEdit={this.handleEdit}
          shouldShowEdit={!shouldShowForm}
          title={title}
        />
        {!!loadingError && <Error>{loadingError}</Error>}
        {!!isLoading && !hasData ? (
          <div>Loading...</div>
        ) : shouldShowForm ? (
          <FormComponent
            {...rest}
            data={data}
            isEditing={isEditing}
            onCancel={this.handleCancel}
            onContinue={onContinue}
            onSave={onSave}
          />
        ) : (
          <DetailsComponent>
            {formData.map(item => (
              <ItemComponent key={item.id || item.tempId} {...rest} {...item} />
            ))}
          </DetailsComponent>
        )}
      </Container>
    );
  }
}

FormPageLayout.propTypes = {
  formComponent: PropTypes.func.isRequired,
  itemComponent: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
  onMount: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,

  data: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  detailsComponent: PropTypes.func,
  hasData: PropTypes.bool,
};

function DefaultDetailsComponent({ children }) {
  return <React.Fragment>{children}</React.Fragment>;
}

DefaultDetailsComponent.propTypes = {
  children: PropTypes.node,
};

FormPageLayout.defaultProps = {
  detailsComponent: DefaultDetailsComponent,
  hasData: false,
};

export default FormPageLayout;



// WEBPACK FOOTER //
// ./src/modules/common/layouts/FormPageLayout.js